import {IBorderRadius} from '../incase-domain/common/borderRadius';

export function getBorderStyle(borderRadius?: IBorderRadius): string {
    const isSet = borderRadius?.upperLeft || borderRadius?.upperRight || borderRadius?.lowerLeft || borderRadius?.lowerRight;

    if (!borderRadius || !isSet) {
        return ``;
    }

    return `${borderRadius?.upperLeft || 0}em ${borderRadius?.upperRight || 0}em ${borderRadius?.lowerRight || 0}em ${
        borderRadius?.lowerLeft || 0
    }em`;
}

export function getCssVariable(variableName: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
}
